export const environment = {
  production: false,
  environment: "local",
  api: "https://localhost:7091/api/",
  filenameCsv: "dev-pos"
};